module.exports = __webpack_public_path__ + "static/media/taizu_thumb_even.70e3b1a9.jpg";